// extracted by mini-css-extract-plugin
export default {"container":"AdminEventAttachments_container__nrb-8","header":"AdminEventAttachments_header__PQPg6"};